import React from 'react';
import { Link } from 'react-router';
import { translate } from 'react-i18next';

import Popover from 'components/popover/Popover.js';

// The Self Schedule nav item and its block menu. App loads the block list once the account is
// known; this only mirrors it, and renders nothing until the company and the employee qualify.
// The menu sits inside the item's own wrapper so the popover's CSS positions it under the item
// wherever the user name pushes it. Rows read like the mobile app: date range, then location and
// department, then where the block stands (window opens, window closes, or under review).
class SelfScheduleNav extends React.Component {
  constructor(props) {
    super(props);

    this._onBlocksChanged = this._onBlocksChanged.bind(this);
    this._onToggle = this._onToggle.bind(this);
    this._onClose = this._onClose.bind(this);
    this._onBlockClicked = this._onBlockClicked.bind(this);

    this.state = {
      open: false,
      popTarget: null,
    };
  }

  componentDidMount() {
    // `reset` is the logout clear.
    SelfScheduleStore.on('self_schedule:blocks:load:success reset', this._onBlocksChanged, this);
  }

  componentWillUnmount() {
    SelfScheduleStore.off(null, null, this);
  }

  _onBlocksChanged() {
    this.forceUpdate();
  }

  _onToggle(e) {
    const popTarget = e.currentTarget;
    this.setState(state => ({ open: !state.open, popTarget }));
  }

  _onClose() {
    this.setState({ open: false, popTarget: null });
  }

  // The Link does the navigating and the route lights the item up; this just closes the menu.
  _onBlockClicked() {
    Utils.removeSpinner();
    this._onClose();
  }

  render() {
    // The department's scheduling model and the employee's pick groups reach Employee Web only
    // through the block list, so the item also needs a block to list. Read on every render rather
    // than kept in state, because a row's status line moves on with the clock (access starts,
    // closes, under review) and a block leaves once its period ends, and nothing announces either.
    // ponytail: no timer, so a row changes at the next header render (a click or a route change),
    // not on the second. Add one keyed to the next window edge if that matters.
    const blocks = SelfScheduleStore.getBlocks();
    if (!SelfScheduleStore.isEnabledForCompany() || blocks.length === 0) {
      return null;
    }

    return (
      <div className="self-schedule-nav">
        <a
          href="javascript:void(0)"
          id="self-schedule-button"
          onClick={this._onToggle}
          className={this.props.active ? 'active' : null}
        >
          <i className="icon-nav-self-schedule" />
          {this.props.t('HeaderBar.self_schedule')}
        </a>
        <Popover
          position="top"
          className="self-schedule-menu"
          onHide={this._onClose}
          active={this.state.open}
          popTarget={this.state.popTarget}
        >
          <ul>
            {blocks.map(block => (
              <li key={block.id}>
                <Link to={`/self-schedule/blocks/${block.id}`} onClick={this._onBlockClicked}>
                  <strong>{block.label}</strong>
                  <span>{block.locationLabel}</span>
                  {block.accessLabel && <small>{block.accessLabel}</small>}
                </Link>
              </li>
            ))}
          </ul>
        </Popover>
      </div>
    );
  }
}

export default translate()(SelfScheduleNav);
